import React from "react";
import { NavLink } from "react-router-dom";

const LogsSubNav = ({ role, handleSettingCurrentPage }) => {
    if (role === 'admin' || role === 'manager' || role === 'supervisor') {
        return (
            <ul>
                <li><NavLink to="logs/actions" onClick={() => handleSettingCurrentPage('logs')}>Actions</NavLink></li>
            {/* <li>
                    <NavLink to="logs/locations" onClick={() => handleSettingCurrentPage('logs')}>
                        Locations
                    </NavLink>
                </li> */}
            </ul>
        );
    }
    return null;
}

export default LogsSubNav;